import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as LoaderSpinner1Icon } from './loaderSpinner1.svg';

export const LoaderSpinner1 = IconHOC(LoaderSpinner1Icon);
